module.exports = __webpack_public_path__ + "static/media/cursor.a3681937.svg";